import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

import { ReactComponent as Menu } from 'icons/hamburger.svg';
import { ReactComponent as Close } from 'icons/close-menu.svg';
import { UserContext } from 'contexts/user';

const MobileNavbar = ({ history, onSignOut }) => {
  const { user } = useContext(UserContext);
  const [showDropdown, setShowDropdown] = useState(false);

  const technitianItems = [
    <div
      key="deliveriesCalendar"
      className="block px1 pt2 pb2"
      onClick={() => {
        history.push('/calendar/exams?view=day');
        setShowDropdown(false);
      }}
    >
      <p className="f3 mb0">Deliveries calendar</p>
    </div>,
  ];

  const doctorItems = [
    <div
      key="agenda"
      className="block px1 pt2 pb2"
      onClick={() => {
        history.push('/calendar/teleconsultations?view=day');
        setShowDropdown(false);
      }}
    >
      <p className="f3 mb0">Agenda</p>
    </div>,
  ];

  const nurseItems = [
    <div
      key="agenda"
      className="block px1 pt2 pb2"
      onClick={() => {
        history.push('/calendar/teleconsultations?view=day');
        setShowDropdown(false);
      }}
    >
      <p className="f3 mb0">Agenda</p>
    </div>,
  ];

  const generalItems = [
    <div
      key="profile"
      className="block px1 pt2 pb2"
      onClick={() => {
        history.push('/profile');
        setShowDropdown(false);
      }}
    >
      <p className="f3 mb0">Profile</p>
    </div>,

    <div key="signOut" className="block px1 pt2 pb2" onClick={onSignOut}>
      <p className="f3 mb0">Sign out</p>
    </div>,
  ];

  return (
    <nav className="th-mobile-nav-bar">
      <div className="flex justify-between items-center">
        {!showDropdown ? (
          <Menu
            className="pointer"
            onClick={() => setShowDropdown(!showDropdown)}
          />
        ) : (
          <Close
            className="pointer"
            onClick={() => setShowDropdown(!showDropdown)}
          />
        )}
        <img
          alt="sd"
          className="h22 fr pointer"
          src="/logo.png"
          onClick={() => window.open('https://app.sleepdoctor.me/')}
        />
      </div>
      {showDropdown && (
        <div className="vh-100 mt20 relative flex flex-column">
          {user?.role === 'technician' && technitianItems}
          {user?.role === 'doctor' && doctorItems}
          {user?.role === 'nurse' && nurseItems}
          {generalItems}
        </div>
      )}
    </nav>
  );
};

MobileNavbar.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  onSignOut: PropTypes.func.isRequired,
};

export default MobileNavbar;
